export default __webpack_public_path__ + "static/media/NoRecentActivityIcon.bb3e6f89.svg";